import { Briefcase, Building2, Users } from 'lucide-react';

import type { UnitType } from '../../hooks/useOrganizationalStructure';
import { odmien } from '../../lib/odmien';

export { odmien };

/**
 * Jeden opis wyglądu typu jednostki dla OBU widoków struktury — listy
 * (`OrgChart.tsx`) i diagramu (`orgChart/OrgChartDiagram.tsx`). Legenda na
 * stronie profilu używa tych samych trzech barw (blue / purple / emerald),
 * więc zmiana koloru w jednym miejscu zmienia go wszędzie.
 */
export const UNIT_CONFIG: Record<
  UnitType,
  {
    icon: typeof Building2;
    label: string;
    labelPl: string;
    /** Mianownik liczby mnogiej do podsumowania: „2 działy”, „14 stanowisk”. */
    liczbaMnoga: (n: number) => string;
    defaultColor: string;
    bgClass: string;
    borderClass: string;
    textClass: string;
  }
> = {
  department: {
    icon: Building2,
    label: 'Department',
    labelPl: 'Dział',
    liczbaMnoga: (n) => odmien(n, 'dział', 'działy', 'działów'),
    defaultColor: '#3B82F6',
    bgClass: 'bg-blue-500/10',
    borderClass: 'border-blue-500/30',
    textClass: 'text-blue-400',
  },
  position: {
    icon: Briefcase,
    label: 'Position',
    labelPl: 'Stanowisko',
    liczbaMnoga: (n) => odmien(n, 'stanowisko', 'stanowiska', 'stanowisk'),
    defaultColor: '#8B5CF6',
    bgClass: 'bg-purple-500/10',
    borderClass: 'border-purple-500/30',
    textClass: 'text-purple-400',
  },
  team: {
    icon: Users,
    label: 'Team',
    labelPl: 'Zespół',
    liczbaMnoga: (n) => odmien(n, 'zespół', 'zespoły', 'zespołów'),
    defaultColor: '#10B981',
    bgClass: 'bg-emerald-500/10',
    borderClass: 'border-emerald-500/30',
    textClass: 'text-emerald-400',
  },
};
